// Firebase Functions Debug Helper
// This helps capture and log Firebase Functions calls for debugging

class FirebaseFunctionsDebugger {
  constructor() {
    this.logs = [];
    this.isEnabled = process.env.NODE_ENV === 'development';
  }

  // Log function call
  logFunctionCall(functionName, data, options = {}) {
    if (!this.isEnabled) return;

    const logEntry = {
      type: 'function_call',
      functionName,
      data,
      options,
      timestamp: new Date().toISOString(),
      id: Math.random().toString(36).substr(2, 9)
    };

    this.logs.push(logEntry);
    
    return logEntry.id;
  }

  // Log function response
  logFunctionResponse(callId, response, error = null) {
    if (!this.isEnabled) return;

    const logEntry = {
      type: 'function_response',
      callId,
      response,
      error,
      timestamp: new Date().toISOString()
    };

    this.logs.push(logEntry);
    
    if (error) {
      console.error(`❌ Firebase Function Error: ${callId}`, error);
    }
  }

  // Get all logs
  getLogs() {
    return this.logs;
  }

  // Clear logs
  clearLogs() {
    this.logs = [];
  }

  // Export logs as JSON
  exportLogs() {
    return JSON.stringify(this.logs, null, 2);
  }

  // Create a wrapped function that automatically logs
  wrapFunction(firebase, functionName) {
    return async (data, options = {}) => {
      const callId = this.logFunctionCall(functionName, data, options);
      
      try {
        const result = await firebase.functions.httpsCallable(functionName)(data);
        this.logFunctionResponse(callId, result.data);
        return result;
      } catch (error) {
        this.logFunctionResponse(callId, null, error);
        throw error;
      }
    };
  }
}

// Create a global instance
const functionsDebugger = new FirebaseFunctionsDebugger();

// Export for use in components
export default functionsDebugger;

// Export a helper to get debug info for sharing
export const getFirebaseFunctionsDebugInfo = () => {
  return {
    logs: functionsDebugger.getLogs(),
    summary: {
      totalCalls: functionsDebugger.logs.filter(log => log.type === 'function_call').length,
      totalErrors: functionsDebugger.logs.filter(log => log.type === 'function_response' && log.error).length,
      totalSuccess: functionsDebugger.logs.filter(log => log.type === 'function_response' && !log.error).length,
      lastCall: functionsDebugger.logs[functionsDebugger.logs.length - 1]
    }
  };
};

